define("command-palette/services/command-palette/private/command-registry", ["exports", "@ember/service", "tracked-built-ins"], function (_exports, _service, _trackedBuiltIns) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/service",0,"tracked-built-ins"eaimeta@70e063a35619d71f

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  class CommandRegistryService extends _service.default {
    constructor() {
      super(...arguments);

      _defineProperty(this, "commands", new _trackedBuiltIns.TrackedObject({}));
    }

    register(commandId, command) {
      if (this.commands[commandId]) {
        throw new Error(`Unable to enable command "${commandId}" because it's already been enabled`);
      }

      this.commands[commandId] = command;
    }

    isRegistered(commandId) {
      return Boolean(this.commands[commandId]);
    }

  }

  _exports.default = CommandRegistryService;
});